import React from 'react';
import { Collapse } from 'react-bootstrap';
import styles from './CourseCollapse.module.scss';
import '../../sass/_float.scss';
import parseDuration from 'youtube-duration-format';

const CourseCollapse = ({ open, openAll, lessons, episodeId, startIndex }) => {
    return (
        <Collapse in={open?.includes(episodeId)}>
            <div className={styles.panelBody}>
                {lessons?.map((lesson, index) => (
                    <div className={styles.lessonItem} key={lesson._id}>
                        <div className={styles.episodeName}>
                            <i
                                className={`${styles.icon} fa-regular fa-circle-play`}
                            ></i>
                            <div className={styles.lessonName}>
                                {startIndex + index + 1}. {'  '} {lesson.title}
                            </div>
                        </div>
                        <span className={`${styles.time} floatRight`}>
                            {lesson?.time ? parseDuration(lesson?.time) : 'N/A'}
                        </span>
                    </div>
                ))}
            </div>
        </Collapse>
    );
};

export default CourseCollapse;
